
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Clock, AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription } from "@/components/ui/alert";

interface GracePeriodBannerProps {
  planType: string;
  hoursRemaining: number;
}

export const GracePeriodBanner = ({ planType, hoursRemaining }: GracePeriodBannerProps) => {
  const navigate = useNavigate();
  
  const planName = planType.charAt(0).toUpperCase() + planType.slice(1);
  const displayHours = Math.max(1, hoursRemaining);
  const displayTime = displayHours >= 24
    ? `${Math.floor(displayHours / 24)} days and ${displayHours % 24} hours`
    : `${displayHours} hours`;
  
  const isUrgent = hoursRemaining < 12;
  
  return (
    <Alert 
      className={`mb-4 ${isUrgent ? 'bg-red-50 border-red-300' : 'bg-amber-50 border-amber-300'}`}
    >
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center">
          {isUrgent ? (
            <AlertTriangle className="h-5 w-5 text-red-600 mr-2" />
          ) : (
            <Clock className="h-5 w-5 text-amber-600 mr-2" />
          )}
          <AlertDescription className={`${isUrgent ? 'text-red-700' : 'text-amber-700'} font-medium`}>
            Your {planName} plan has expired! You have {displayTime} of grace period remaining before losing access.
          </AlertDescription>
        </div>
        <Button
          variant={isUrgent ? "destructive" : "outline"}
          size="sm"
          className={isUrgent ? "" : "bg-amber-500 hover:bg-amber-600 text-white"}
          onClick={() => navigate('/subscription/plans')}
        >
          Upgrade Now
        </Button>
      </div>
    </Alert>
  );
};
